import { useInView } from 'react-intersection-observer';
import isChromatic from 'chromatic/isChromatic';
import { generateClassName } from '@klv/shared/utils/functions';

import type { IFadeInUpProps } from './types';
import * as styles from './styles/fade-in-up.module.css';
import { useEffect, useState } from 'react';

const FadeInUp = ({
  className,
  children,
  threshold = .25,
}: IFadeInUpProps) => {
  const { ref, inView } = useInView({ threshold: threshold });
  const [isInView, setIsInView] = useState(false);
  
  useEffect(() => {
    if ((inView && !isInView) || isChromatic()) {
      setIsInView(true);
    }
  }, [inView, isInView]);

  return (
    <div 
      className={generateClassName([className, styles.fadeInUp, isInView ? styles.inView : ''])} 
      ref={ref}
      children={children}
    />
  );
};

export default FadeInUp;
